import { faSpinnerThird } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CSSProperties } from "react";

import { cn } from "~/lib/utils";

type Props = {
  width?: string | number;
  height?: string | number;
  color?: string;
  style?: CSSProperties;
  className?: string;
};

export function LoadingSpinner(props: Props) {
  return (
    <div
      className={cn(
        "flex animate-spin items-center justify-center text-inherit",
        props.className,
      )}
      style={{
        width: props.width,
        height: props.height,
        ...props.style,
      }}
    >
      <FontAwesomeIcon
        style={{
          color: props.color,
          width: props.width,
          height: props.height,
        }}
        icon={faSpinnerThird}
        className="fill-black"
      />
    </div>
  );
}
